<script>
import { SupplierServices } from "@/services/nextshop/supplier.service";
import { EmployeeService } from '@/services/nextshop/employee.service';
// import { OtherService } from "@/services/other.service";
// import Swal from "sweetalert2";
import RowWrapper from "@/components/wrappers/RowWrapper";
import { CustomerServices } from "@/services/nextshop/customer.service";
import { statusCheckInStorage } from "../../utils/mapping";
import { DebtService } from "@/services/nextshop/debt.service";
import { getStatus } from "../debtnote/utils.js";
import { formatHHmmDDMMYYYY } from "../../utils/format";
import getListLocation from "@/mixins/items/getListLocation";
import StatusBox from "@/components/status-box.vue";
import moment from "moment";
import { getAllAddressName } from "@/utils/address";
import baseExpandInfo from '@/components/base-expand-info.vue';


export default {
  page: {
    title: "Chi tiết nhà cung cấp",
  },
  components: {
    RowWrapper,
    StatusBox,
    baseExpandInfo
  },
  mixins: [
    getListLocation,
  ],
  data() {
    return {
      filterHistory: '',
      filterDebit: '',
      updateUI: 1,
      filter: "",
      filterHistoryModal: false,
      selectedStatusOrder: null,
      dateRange: [],
      listStatusOrder: [
        { id: "ALL", text: "Tất cả" },
        { id: "COMPLETE", text: "Hoàn thành" },
        { id: "NEW", text: "Đang xử lí" },
        { id: "CANCEL", text: "Đã hủy" },
      ],
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      loading: false,
      isShow: false,
      inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
      title: "CHI TIẾT NHÀ CUNG CẤP",
      items: [
        {
          text: "Nhà cung cấp",
          href:
            JSON.parse(localStorage.getItem("dataPermission")) && JSON.parse(localStorage.getItem("dataPermission")).includes("NSH_PARTNER_SUP_VIEW")
              ? "/supplier-list"
              : "#",
        },
        {
          text: "Chi tiết nhà cung cấp",
          active: true,
        },
      ],
      //DEBT
      selectedType: null,
      selectedStatus: null,
      delSupplierModal: false,
      filterDebitModal: false,
      delContactModal: false,
      activeContact: {},
      dateRangeDebit: [],
      locationNameTmp: "",
      listType: [
        { id: "ALL", text: "Tất cả" },
        { id: "lending", text: "Khoản phải thu" },
        { id: "borrowing", text: "Khoản phải trả" },
      ],
      listStatus: [
        { id: "ALL", text: "Tất cả" },
        { id: "OPEN", text: "Chưa thanh toán" },
        { id: "REPAYING", text: "Thanh toán 1 phần" },
        { id: "OVERDUE", text: "Quá hạn" },
      ],
      textSearch: "",
      selected: [],
      optionsPerPage: [
        { value: 5, text: "5" },
        { value: 10, text: "10" },
        { value: 30, text: "30" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      listSource: [
        { id: "ALL", text: "Tất cả" },
        {
          id: "NEXT_SHOP_POS_APP",
          text: "POS App",
        },
        {
          id: "NEXT_SHOP_POS_WEB",
          text: "POS Web",
        },
        {
          id: "ONLINE_STORE",
          text: "Gian hàng trực tuyến",
        },
      ],
      fields: [
        {
          key: "selected",
          label: "",
          thStyle: { width: "1%" },
        },
        {
          key: "name",
          label: "Họ tên",
          thStyle: { width: "15%" },
        },
        {
          key: "phone",
          label: "Số điện thoại",
          thStyle: { width: "15%" },
        },
        {
          key: "relationship",
          label: "Mối quan hệ với khách hàng",
          thStyle: { width: "10%" },
        },
        {
          key: "manipulation",
          label: "",
          tdClass: "text-right",
          thStyle: { width: "5%" },
        },
      ],
      filterOn: [],
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      dataSupplier: [],
      dataContacts: [],
      avatarDefault: "https://huyhoanhotel.com/wp-content/uploads/2016/05/765-default-avatar.png",
      dataContact: {},
      modalContact: false,
      adding: true,
      addressInfor: [],
      address: "",
      // addressName: {
      //   city: "",
      //   district: "",
      //   ward: "",
      // },
      listCreater: [],
      importProductData: [],
      importProduct: {
        rows: 0,
        data: [],
        fields: [
          {
          label: "Mã đơn",
          key: "orderNo",
          },
          {
            label: "Kho nhận",
            key: "locationToCreate",
          },
          {
            label: "Trạng thái",
            key: "processorStatusText",
          },
          {
            label: "Ngày ghi nhận",
            key: "updatedAt",
          },
          {
            label: "Người tạo",
            key: "creator",
          },
        ],
        search: {
          "pageNum": 1,
          "pageSize": 5,
          "queryString": '',
          "sortBy": "",
          "sortType": "ASC"
        },
        currentPage: 1,
      },
      debtNote: {
        rows: 0,
        data: [],
        fields: [
          {
            key: "title",
            label: "Tên khoản nợ",
            thStyle: { width: "20%" }
          },
          {
            key: "type",
            label: "Loại khoản",
            thStyle: { width: "10%" },
          },
          {
            key: "dueAt",
            label: "Hạn trả",
            thStyle: { width: "15%" },
          },
          {
            key: "status",
            label: "Trạng thái",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: { width: "15%", minWidth: "140px" },
          },
          {
            key: "principal",
            label: "Nợ gốc",
            thStyle: { width: "15%" },
          },
          {
            key: "repay",
            label: "Đã thanh toán",
            thStyle: { width: "15%" },
          },
          {
            key: "balance",
            label: "Còn lại",
            thStyle: { width: "15%" },
          },
        ],
        search: {
          queryString: "",
          newPagingAndSorting: {
            page: 1,
            perPage: 2,
            sort: "_id"
          }
        }
      },
      searchDebtTmp: [],
      createrId: "",
      addressObj: null,
      dataReport: [
        {
          text: "Phải thu của NCC",
          value: 0
        },
        {
          text: "Phải trả cho NCC",
          value: 0
        }
      ],
      totalBorrowing: 0,
      totalLending: 0
    };
  },
  async created() {
    await this.fetchData();
    this.getDebtNoteData();
    this.getImportProductData();
    this.getListCreater();
    this.getAddress(),
    this.getTotallDebit()
  },
  methods: {
    async getAddress() {
      this.addressObj = await getAllAddressName(this.dataSupplier.cityCode, this.dataSupplier.districtCode, this.dataSupplier.wardCode);
    },
    async changeCurrentPage(page) {
      this.importProduct.currentPage = page
      this.loading = true
      await this.getImportProductData();
      this.loading = false
    },
    myRowClickHandler(record) {
      this.$router.push({ path: `/debt_detail/${record.id}` });
    },
    getStatus,
    async getDebtNoteData() {
      this.loading = true;
      this.debtNote.data = []
      this.searchDebtTmp = [`{partnerId} == '''${this.dataSupplier.id}'''`]
      if(this.selectedType != null && this.selectedType.id != 'ALL') {
        this.searchDebtTmp.push(`{type} == '''${this.selectedType.id}'''`)
      }
      if(this.selectedStatus != null && this.selectedStatus.id != 'ALL') {
        this.searchDebtTmp.push(`{status} == '''${this.selectedStatus.id}'''`)
      }
      if (this.dateRangeDebit[0] != undefined || this.dateRangeDebit[1] != undefined) {
        const dateFrom = moment(this.dateRangeDebit[0]).format("YYYY-MM-DD") + `T00:00:00.000Z`
        const dateTo = moment(this.dateRangeDebit[1]).format("YYYY-MM-DD") + `T23:59:59.000Z`
        this.searchDebtTmp.push(`{dueAt} range [#${dateFrom}#, #${dateTo}#]`)
      }
      if(this.filterDebit.trim() != "") {
        this.searchDebtTmp.push(`{title} == '''${this.filterDebit}'''`)
      }
      if (this.searchDebtTmp.length) {
        this.debtNote.search.queryString = this.searchDebtTmp.join(" and ");
      }
      
      try {
        const response = await DebtService.getDebtAccomplishedv2(this.debtNote.search);
        if (response.success) {
          this.debtNote.data = response.data;
        } else {
          console.log(response.data);
        }
      } catch (error) {
        console.log(error);
      }
      finally {
        this.loading = false;
        this.filterDebitModal = false;
      }
    },
    async getListCreater() {
      try {
        const data = await EmployeeService.listEmployeeLocation({
            merchantId: JSON.parse(localStorage.getItem("auth.currentMerchant")).id,
            locationId: JSON.parse(localStorage.getItem("LID")),
            userType: JSON.parse(localStorage.getItem("auth.currentUser")).role
        });
        if (data.success) {
          this.listCreater = data.data.map((e) => {
            return {
              id: e.coAliasUserId,
              text: e.name,
            };
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    removeFilterHistory(){
      this.selectedStatusOrder = null
      this.createrId = null
      this.dateRange = []
      this.getImportProductData();
    },
    changeCurrentPageHistory(page){
      this.currentPageHistory = page
      this.searchOrder.pageNum = page;
      this.getImportProductData();
    },
    
    removeDebitHistory(){
      this.selectedType = null
      this.selectedStatus = null
      this.dateRangeDebit = []
      this.getDebtNoteData();
    },
    async getImportProductData() {
      this.loading = true
      this.importProduct.data = null
      this.importProductData = [`{orderType} == '''IO''' and {furtherInstructions.key} =='''CHECK_IN''' and {partyB.resId} == '''${this.$route.params.id}'''`]
      if (this.selectedStatusOrder && this.selectedStatusOrder.id !== "ALL") {
        switch (this.selectedStatusOrder.id) {
          case "COMPLETE":
            this.importProductData.push("{orderStatus} == '''SUCCESS'''");
            break;
          case "NEW":
            this.importProductData.push(
              "{orderStatus} == '''DRAFT'''"
            );
            break;
          case "CANCEL":
            this.importProductData.push(
              "({orderStatus} == '''TIMEOUT''' or {orderStatus} == '''CANCEL''')"
            );
            break;
        }
      }
      if (this.createrId) {
        this.importProductData.push(`{createdBy} == '''${this.createrId.id}'''`);
      }
      if (this.dateRange.length > 0) {
        this.importProductData.push(
          "{createdAt} >= #" +
            moment(this.dateRange[0]).format('YYYY-MM-DD') +
            "T00:00:00.00+07:00# and {createdAt} <= #" +
              moment(this.dateRange[1]).format('YYYY-MM-DD') +
            "T23:59:59.00+07:00#"
        );
      }
      if (this.filterHistory.trim() != '') {
        this.importProductData.push(`{orderNo} == '''${this.filterHistory}'''`);
      }
      if (this.importProductData.length) {
        this.importProduct.search.queryString = this.importProductData.join(" and ");
      }
      try {
        const response = await CustomerServices.getDetailHistoryBuy(this.importProduct.search);
        if (response.success) {
          this.importProduct.data = response.data.orders.map(item => {
              const { furtherInstructions } = item
              return {
              ...item,
              creator: furtherInstructions[0].params.employeeName,
              updatedAt: formatHHmmDDMMYYYY(item.updatedAt),
              locationToCreate: this.getNameLocation(item.locationToCreate),
              processorStatusText: statusCheckInStorage(item.processorStatus).text,
              processorStatusDisplay: statusCheckInStorage(item.processorStatus),
            }
          })
          this.importProduct.rows = response.data.totalElements
        } else {
          console.log(response);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false
        this.filterHistoryModal = false
      }
    },
    // allow input number
    allowNumbersOnly($event) {
      if (!["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes($event.key) && $event.keyCode !== 8) {
        $event.preventDefault();
      }
    },
    editItem() {
      this.$router.push({
        path: `/supplier-list/supplier-edit/${this.$route.params.id}`,
      });
    },
    remove() {
      this.filter = "";
    },
    removeDebit() {
      this.filterDebit = "";
    },
    removeHistory(){
      this.filterHistory = "";
    },
    async fetchData() {
      this.loading = true;
      try {
        const response = await CustomerServices.getCustomerById({
          merchantId: this.inforAccount.merchantId,
          query: this.$route.params.id,
        });
        if (response.success) {
          this.dataSupplier = response.data;
          this.dataContacts = response.data.contacts;
          this.totalRows = this.dataContacts.length;
          this.dataContacts.id = response.data.contacts.map((e) => {
            e.id = Math.floor(Math.random() * 10000000);
          });
          this.dataSupplier.address ? this.addressInfor.push(this.dataSupplier.address) : "";
          this.loading = false;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        this.isShow = true;
      }
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    //Delete item
    clickDeleteContactMore(){
      this.modalRemoveContactMore = true
    },
    async deleteSupplier() {
      this.loading = true;
      try {
        const response = await SupplierServices.deleteSupplier({
          merchantId: this.inforAccount.merchantId,
          partnerIds: [this.$route.params.id],
        });
        if (response.success) {
          this.deletemsg();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    deletemsg() {
      // Swal.fire({
      //   title: "Thành công",
      //   text: `Đã cập nhật thông tin thành công!`,
      //   icon: "success",
      //   confirmButtonText: "Xác nhận",
      // }).then((result) => {
      //   if (result.value) {
      //     this.$router.push({ path: `/supplier-list` });
      //   }
      // });
      this.showNotify("Thành công", "Đã xóa nhà cung cấp!", "success")
      this.$router.push({ path: `/supplier-list` });

    },
    clickAdd() {
      this.adding = true;
      this.dataContact = {};
      this.modalContact = true;
    },
    clickEdit(data) {
      this.adding = false;
      this.dataContact = {
        id: data.id,
        name: data.name,
        phone: data.phone,
        rule: data.rule,
      };
      this.modalContact = true;
    },
    clickDelete(data) {
      this.modalContact = false;
      this.activeContact = data;
      console.log(this.activeContact);
      this.delContactModal = true
    },
    destroyModal() {
      this.modalContact = false;
    },
    successmsg() {
      // Swal.fire({
      //   title: "Thành công",
      //   text: this.adding ? "Đã tạo mới liên hệ thành công!" : "Đã cập nhật thông tin thành công!",
      //   icon: "success",
      //   confirmButtonText: "Xác nhận",
      // }).then((result) => {
      //   if (result.value) {
      //     this.fetchData();
      //   }
      // });
      this.showNotify("Thành công", this.adding ? "Đã tạo mới liên hệ thành công!" : "Đã cập nhật thông tin thành công!", "success")
      this.fetchData();
    },
    deletemsgcontact() {
      // Swal.fire({
      //   title: "Thành công",
      //   text: this.adding ? "Đã tạo mới liên hệ thành công!" : "Đã cập nhật thông tin thành công!",
      //   icon: "success",
      //   confirmButtonText: "Tiếp tục",
      // }).then((result) => {
      //   if (result.value) {
      //     this.fetchData();
      //   }
      // });
      this.showNotify("Thành công", "Đã xóa liên hệ thành công", "success")
      this.fetchData();
    },
    async saveItem(validate) {
      validate().then(async (success) => {
        if (!success) {
          const el = document.querySelector(".is-invalid");
          el.focus();
          return;
        }
        if (this.adding) {
          this.dataContacts.push(this.dataContact);
        }
        {
          const index = this.dataContacts.findIndex((e) => {
            return e.id === this.dataContact.id;
          });
          if (index !== -1) {
            this.dataContacts.splice(index, 1, this.dataContact);
          }
        }

        const params = {
          id: this.dataSupplier.id,
          contacts: this.dataContacts,
          version: this.dataSupplier.version,
        };
        this.loading = true;
        try {
          const response = await CustomerServices.contact(params);
          if (response.success) {
            this.loading = false;
            this.successmsg();
          }
          this.destroyModal();
        } catch (error) {
          this.loading = false;
          console.log(error);
        } finally {
          this.loading = false;
        }
      });
    },
    async saveDelete() {
      const index = this.dataContacts.findIndex((e) => {
        return e.id === this.activeContact.id;
      });
      this.dataContacts.splice(index, 1);
      this.loading = true;
      const params = {
        id: this.dataSupplier.id,
        contacts: this.dataContacts,
        version: this.dataSupplier.version,
      };
      console.log(params);
      try {
        const response = await CustomerServices.contact(params);
        if (response.success) {
          this.loading = false;
          this.delContactModal = false
          this.deletemsgcontact();
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    getCheckInData(item) {
      const CHECK_IN_DATA = item?.furtherInstructions?.find(e => e.key == "CHECK_IN") || null
      return CHECK_IN_DATA
    },
    async getTotallDebit(){
      const merchantId = this.inforAccount.merchantId
      const partnerId = this.$route.params.id
      const response = await CustomerServices.getTotallDebit(merchantId, partnerId)
      if(response.success){
        this.totalLending = (response.data.lending) ? this.divisionThousand(response.data.lending.totalAmount - response.data.lending.paidAmount) : 0
        this.totalBorrowing = (response.data.borrowing) ? this.divisionThousand(response.data.borrowing.totalAmount - response.data.borrowing.paidAmount) : 0
        this.dataReport[0].value = this.formatMoneyNotUnit(this.totalLending)
        this.dataReport[1].value = this.formatMoneyNotUnit(this.totalBorrowing)
      }
    }
  },
  computed: {
    rows() {
      return this.dataContact.length;
    },
    selectAll: {
      get: function () {
        if (this.selected.length === this.dataContacts.length) {
          return "TRUE"
        } else if (this.selected.length === 0) {
          return "FALSE"
        } else {
          return "ORTHER"
        }
      },
      set: function (value) {
        var selected = []
        if (value) {
          this.dataContacts.forEach(function (item) {
            selected.push(item)
          })
        }
        this.selected = selected
      },
    },
    // listLocations() {
    //   let location = [{ id: "ALL", name: "Tất cả" }];
    //   this.currentUser.locationInfos.filter((e) => {
    //     location.push({ id: e.id, name: e.name });
    //   });
    //   return location;
    // },
  },
};
</script>

<style lang="scss">
.debt-title {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  margin: auto;
}
</style>

<template>
  <div>
    <div v-if="dataPermission && dataPermission.includes('NSH_PARTNER_SUP_VIEW')">
      <!-- moi -->
      <div class="layout-wrapper">
        <header id="page-topbar">
          <el-button class="btn-info" @click="$router.go(-1)">Quay lại</el-button>

          <div class="title">
            <p>Chi tiết nhà cung cấp</p>
          </div>

          <div class="row">
            <el-button v-if="dataPermission && dataPermission.includes('NSH_PARTNER_GROUP_SUP_DELETE')" @click="delSupplierModal = true" type="danger" plain>Xoá nhà cung cấp</el-button>
          </div>
        </header>
      </div>

      <div class="container" style="margin-top: 96px;">
        <div v-if="dataPermission && dataPermission.includes('NSH_PARTNER_SUP_VIEW')">
          <b-card class="form_card_custom">
            <div class="d-flex justify-content-between align-items-center">
              <div class="form-card_title">Thông tin cá nhân</div>
              <div>
                <el-button @click="editItem" v-if="dataPermission && dataPermission.includes('NSH_PARTNER_SUP_UPDATE')">Chỉnh sửa</el-button>
              </div>
            </div>

            <div class="row my-4">
              <div class="sub_title col-2 text-right">Tên NCC</div>
              <div class="col-4">{{ dataSupplier.name }}</div>
              <div class="sub_title col-2 text-right">Số điện thoại</div>
              <div class="col-4">{{ dataSupplier.phoneNo ? dataSupplier.phoneNo : "---" }}</div>
            </div>
            <div class="row my-4">
              <div class="sub_title col-2 text-right">Nhóm</div>
              <div class="col-4">{{ dataSupplier.groups.length > 0 ? dataSupplier.groups[0].name : "---" }}</div>
              <div class="sub_title col-2 text-right">Phân loại</div>
              <div class="col-4">{{ dataSupplier.isPerson ? "Cá nhân" : "Doanh nghiệp" }}</div>
            </div>
            <div class="row my-4">
              <div class="sub_title col-2 text-right">Giới tính</div>
              <div class="col-4">{{ "---" }}</div>
              <div class="sub_title col-2 text-right">Tỉnh /Thành phố</div>
              <div class="col-4">{{ addressObj && addressObj.cityName || "---" }}</div>
            </div>
            <div class="row my-4">
              <div class="sub_title col-2 text-right">Quận/ Huyện</div>
              <div class="col-4">{{ addressObj && addressObj.districtName || "---"}}</div>
              <div class="sub_title col-2 text-right">Xã/ Phường</div>
              <div class="col-4">{{ addressObj && addressObj.wardName || "---"}}</div>
            </div>
            <div class="row my-4">
              <div class="sub_title col-2 text-right">Địa chỉ cụ thể</div>
              <div class="col-10">{{ dataSupplier.address ? dataSupplier.address : "---" }}</div>
            </div>
          </b-card>


          <!-- lich su nhap hang -->
          <b-card class="form_card_custom">
            <div class="d-flex justify-content-between align-items-center">
              <div class="form-card_title">Lịch sử nhập hàng</div>
            </div>
            <div class="row my-4 d-flex">
              <div class="col">
                <div class="mb-3">
                    <b-input-group class="wrapperInput">
                      <el-popover
                        placement="bottom-start"
                        width="500px"
                        trigger="click"
                        v-model="filterHistoryModal"
                      >
                      <div class="boxPopovers">
                        <div class="d-flex justify-content-between">
                          <multiselect
                              v-model="selectedStatusOrder"
                              :options="listStatusOrder"
                              deselectLabel=""
                              selectLabel=""
                              selectedLabel=""
                              placeholder="Trạng thái đơn"
                              label="text"
                              track-by="id"
                              class="mr-1"
                            >
                            </multiselect>
                            <multiselect
                              v-model="createrId"
                              :options="listCreater"
                              placeholder="Người tạo"
                              deselectLabel=""
                              selectLabel=""
                              selectedLabel=""
                              label="text"
                              track-by="id"
                              class="mr-1">
                            </multiselect>
                        </div>
                        <div class="mt-2 clearfix">
                          <span class="col-4" style="position: relative; top: 10px;">Ngày ghi nhận:</span>
                          <el-date-picker
                            class="el col-8 pull-right"
                            type="daterange"
                            align="right"
                            start-placeholder="Từ ngày"
                            end-placeholder="Đến ngày"
                            format="dd/MM/yyyy"
                            v-model="dateRange"
                            :clearable="false">
                          </el-date-picker>
                        </div>
                        <div class="mt-2 clearfix text-right">
                          <BaseButton variant="outline" class="ml-3 b-primary pull-right" @click="getImportProductData">Áp dụng bộ lọc</BaseButton>
                          <BaseButton variant="outline" class="ml-3 b-remove pull-right" @click="removeFilterHistory">Xóa bộ lọc</BaseButton>
                          <BaseButton variant="primary" class="ml-3 b-destroy pull-right" @click="filterHistoryModal = false">Huỷ</BaseButton>
                        </div>
                      </div>

                      <el-button slot="reference" class="btn-info btn-filter mr-2">
                        <img src="@/assets/images/filter.svg">
                        Bộ lọc</el-button>
                      </el-popover>
                      <el-input
                        class="w-25 flex-1"
                        placeholder="Tìm kiếm theo mã đơn hàng"
                        clearable=""
                        v-model="filterHistory">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                      </el-input>
                    </b-input-group>
                  </div>
                <b-table
                  class="mt-3"
                  hover
                  :key="updateUI"
                  :items="importProduct.data"
                  :fields="importProduct.fields"
                  show-empty
                  :current-page="currentPage"
                  :per-page="perPage"
                  tbody-tr-class="row-table-class"
                  :filter="filterHistory"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                >
                  <template #empty>
                    <h4 class="text-center text-secondary">Không có dữ liệu hiển thị!</h4>
                  </template>
                  <template #cell(orderNo)="data">
                    <div @click="linkTo(item.id)" style="cursor: pointer">
                      {{ data.item.orderNo }}
                    </div>
                  </template>
                  <template #cell(processorStatusText)="data">
                    <base-tag :type="data.item.processorStatusDisplay.color">{{ data.item.processorStatusDisplay.text }}</base-tag>
                  </template>
                  <template #cell(createdAt)="data">
                    <p style="margin: 0px">
                      {{ data.item.createdAt | formatDate }}
                    </p>
                  </template>
                  <template #cell(locationToCreate)="data">
                    <div>
                      {{ getCheckInData(data.item) && getCheckInData(data.item).params.toInventoryName}}
                    </div>
                  </template>
                  <template #cell(createdBy)="data">
                    <div>
                      {{ getCheckInData(data.item) && getCheckInData(data.item).params.employeeName}}
                    </div>
                  </template>
                </b-table>
                <div class="w-100 d-flex justify-content-end">
                  <b-pagination
                    @change="changeCurrentPage"
                    :total-rows="importProduct.rows"
                    v-model="importProduct.currentPage"
                    :per-page="importProduct.perPage"
                    aria-controls="debt-table"
                    hide-goto-end-buttons
                    limit="5"
                    last-text="next"
                    align="right"
                  />
                </div>
              </div>
            </div>
          </b-card>

          <!-- so cong no -->
          <b-card class="form_card_custom">
            <div class="d-flex justify-content-between align-items-center">
              <div class="form-card_title">Sổ công nợ</div>
            </div>
            <base-expand-info :dataReport="dataReport"/>
            <div class="row my-4 d-flex">
              <div class="col">
                <!-- <el-button class="mr-2" type="info" plain>Bộ lọc</el-button>
                <el-input style="width: 248px !important;" class="w-25" prefix-icon="el-icon-search" v-model="filterDebit" placeholder="Tìm kiếm theo mã khoản nợ" clearable=""></el-input> -->
                <div class="mb-3">
                  <b-input-group class="wrapperInput">
                    <el-popover
                      placement="bottom-start"
                      width="500px"
                      trigger="click"
                      v-model="filterDebitModal"
                    >
                      <div class="boxPopovers">
                        <div class="d-flex justify-content-between">
                          <multiselect
                          v-model="selectedType"
                          :options="listType"
                          deselectLabel=""
                          selectLabel=""
                          selectedLabel=""
                          placeholder="Loại khoản"
                          label="text"
                          track-by="id"
                          class="mr-2"
                        >
                        </multiselect>
                        <multiselect
                          v-model="selectedStatus"
                          :options="listStatus"
                          deselectLabel=""
                          selectLabel=""
                          selectedLabel=""
                          placeholder="Trạng thái"
                          label="text"
                          track-by="id"
                        >
                        </multiselect>
                        </div>
                        <div class="mt-2 clearfix">
                        <span class="col-4" style="position: relative; top: 10px;">Hạn trả:</span>
                        <el-date-picker
                          class="el col-8 pull-right"
                          type="daterange"
                          align="right"
                          start-placeholder="Từ ngày"
                          end-placeholder="Đến ngày"
                          format="dd/MM/yyyy"
                          v-model="dateRangeDebit"
                          :clearable="false">
                        </el-date-picker>
                      </div>
                      <div class="mt-2 clearfix text-right">
                        <BaseButton variant="outline" class="ml-3 b-primary pull-right" @click="getDebtNoteData">Áp dụng bộ lọc</BaseButton>
                        <BaseButton variant="outline" class="ml-3 b-remove pull-right" @click="removeDebitHistory">Xóa bộ lọc</BaseButton>
                        <BaseButton variant="primary" class="ml-3 b-destroy pull-right" @click="filterDebitModal = false">Huỷ</BaseButton>
                      </div>
                      </div>

                      <el-button slot="reference" class="btn-info btn-filter mr-2">
                        <img src="@/assets/images/filter.svg">
                        Bộ lọc
                      </el-button>
                    </el-popover>

                    <el-input
                      class="w-25 flex-1"
                      placeholder="Tìm kiếm theo tên khoản nợ"
                      clearable=""
                      v-model="filterDebit">
                      <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                  </b-input-group>
                </div>
                <b-table
                  class="mt-3"
                  hover
                  :items="debtNote.data"
                  :fields="debtNote.fields"
                  :current-page="debtNote.currentPage"
                  :per-page="debtNote.perPage"
                  @row-clicked="myRowClickHandler"
                  :filter="filterDebit"
                  show-empty
                >
                  <template #empty>
                    <h4 class="text-center text-secondary">Không có dữ liệu hiển thị!</h4>
                  </template>
                  <template #cell(title)="data">
                    <span style="cursor: pointer" class="pt-15 text-bold text-primary debt-title" @click="() => this.$router.push({ path: `/debt_detail/${data.item.id}` })">
                      {{ data.item.title }}
                    </span>
                  </template>
                  <template #cell(status)="data">
                    <StatusBox class="m-auto" :status="getStatus(data.item.status).status" :showText="getStatus(data.item.status).text"></StatusBox>
                  </template>
                  <template #cell(dueAt)="data">
                    <p style="margin: 0px">
                      {{ data.item.dueAt | formatDate }}
                    </p>
                  </template>
                  <template #cell(type)="data">
                    <div v-if="data.item.type === 'lending'">Khoản phải thu</div>
                    <div v-if="data.item.type === 'borrowing'">Khoản phải trả</div>
                  </template>
                  <template #cell(balance)="data">
                    <div div class="text-bold" style="white-space: nowrap">
                      {{ divisionThousand(data.item.balance).toLocaleString() }}
                    </div>
                  </template>
                  <template #cell(repay)="data">
                    <div div class="text-bold" style="white-space: nowrap">
                      {{ divisionThousand(data.item.principal - data.item.balance ? data.item.principal - data.item.balance : 0).toLocaleString() }}
                    </div>
                  </template>
                  <template #cell(principal)="data">
                    <div class="text-bold" style="margin: 0px; white-space: nowrap">
                      {{ divisionThousand(data.item.principal).toLocaleString() }}
                    </div>
                  </template>
                </b-table>
                <div class="w-100 d-flex justify-content-end">
                  <b-pagination
                    :total-rows="debtNote.data.length"
                    v-model="debtNote.currentPage"
                    :per-page="debtNote.perPage"
                    aria-controls="debt-table"
                    hide-goto-end-buttons
                    limit="5"
                    last-text="next"
                    align="right"
                  />
                </div>
              </div>
            </div>
          </b-card>

          <b-card class="form_card_custom">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="form-card_title">Thông tin liên hệ khác</div>
              <div>
                <el-button type="primary" plain v-if="dataPermission && dataPermission.includes('NSH_PARTNER_SUP_UPDATE')" @click="clickAdd()">Thêm mới liên hệ</el-button>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <!-- <el-input prefix-icon="el-icon-search" v-model="filter" placeholder="Tìm kiếm theo tên, sđt" clearable="" class="w-100 my-3"></el-input> -->
                <div class="row mb-3">
                  <div :class="selected.length > 0 ? 'col-lg-8' : 'col-lg-12'">
                    <el-input
                      class="w-100"
                      placeholder="Tìm kiếm theo tên, sđt"
                      clearable=""
                      v-model="filter">
                      <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                  </div>

                  <div class="col-lg-4 text-right" v-if="selected.length > 0">
                    <span class="mt-2 mr-2">Đã chọn {{selected.length}} liên hệ</span>
                    <b-button variant="danger" @click="clickDeleteContactMore" class="btn-xs btn-danger-ext">Xóa</b-button>
                  </div>
                </div>

                <b-table
                  hover
                  :items="dataContacts"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  tbody-tr-class="row-table-class"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  show-empty
                >
                  <template #empty>
                    <h4 class="text-center text-secondary">Không có dữ liệu hiển thị!</h4>
                  </template>
                  <template v-slot:head(selected)="data">
                    <BaseCheckbox
                      v-model="selectAll"
                      :value="data.item"
                    />
                  </template>
                  <template #cell(selected)="data">
                    <BaseCheckbox
                      v-model="selected"
                      :value="data.item">
                    </BaseCheckbox>
                  </template>
                  <template #cell(name)="data">
                    <span class="text-primary" @click="clickEdit(data.item)">
                      <p style="margin: 0px; white-space: nowrap">
                        {{ data.item.name }}
                      </p>
                    </span>
                  </template>
                  <template #cell(phone)="data">
                    <p style="margin: 0px; white-space: nowrap">
                      {{ data.item.phone }}
                    </p>
                  </template>
                  <template #cell(relationship)="data">
                    <p style="margin: 0px; white-space: nowrap">
                      {{ data.item.rule }}
                    </p>
                  </template>
                  <template #cell(manipulation)="data">
                    <div class="text-center">
                      <span
                        v-if="dataPermission && dataPermission.includes('NSH_PARTNER_SUP_UPDATE')"
                        @click="clickDelete(data.item)"
                        class="btn-sm btn-ext"
                        ><i class="fa fa-close fz-15 color-red"></i
                      ></span>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </b-card>
        </div>
      </div>

      <!-- cu -->
      <div class="box-loading" v-if="loading">
        <div class="loading">
          <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
        </div>
      </div>
      <b-modal modal-class="custom_theo_design" v-model="modalContact" centered hide-footer no-close-on-backdrop>
        <template #modal-header>
          <h4 v-if="adding" class="title-modal-custom mb-0">Thêm mới liên hệ</h4>
          <h4 v-else class="title-modal-custom mb-0">Chỉnh sửa liên hệ</h4>
          <button type="button" aria-label="Close" class="close" @click="destroyModal">
            <i class="el-icon-close"></i>
          </button>
        </template>
        <validation-observer ref="observerPartner" v-slot="{ validate }">
          <RowWrapper>
            <template #center>
              <RowWrapper>
                <template #center>
                  <b-form-group label="" label-for="formrow-groupname-input">
                    <validation-provider name="Tên liên hệ" rules="required|lBetween:1,255|CHECK_HTML" v-slot="{ errors, valid }">
                      <label>Tên liên hệ<sup class="text-danger"> * </sup></label>

                      <b-form-input
                        id="formrow-groupname-input"
                        type="text"
                        placeholder="Nhập tên liên hệ"
                        v-model="dataContact.name"
                        :state="errors[0] ? false : valid ? true : null"
                        @keydown.enter.prevent
                      />

                      <b-form-invalid-feedback>
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-form-group>
                </template>
              </RowWrapper>

              <RowWrapper>
                <template #center>
                  <b-form-group label="" label-for="formrow-phone-input">
                    <validation-provider name="Số điện thoại" rules="PHONE_NO_3|CHECK_HTML|lBetween:1,15|required" v-slot="{ errors, valid }">
                      <label>Số điện thoại<sup class="text-danger"> * </sup></label>
                      <b-form-input
                        id="formrow-phone-input"
                        type="text"
                        placeholder="Nhập số điện thoại"
                        v-model.trim="dataContact.phone"
                        @keydown.enter.prevent
                        @keydown="allowNumbersOnly"
                        :state="errors[0] ? false : valid ? true : null"
                      />
                      <b-form-invalid-feedback>
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-form-group>
                </template>
              </RowWrapper>
              <RowWrapper>
                <template #center>
                  <b-form-group label="" label-for="formrow-rule-input">
                    <validation-provider name="Mối quan hệ" rules="lBetween:0,255|CHECK_HTML" v-slot="{ errors, valid }">
                      <label>Mối quan hệ</label>

                      <b-form-input
                        v-model.trim="dataContact.rule"
                        id="formrow-rule-input"
                        class="form-control"
                        placeholder="Nhập môi quan hệ"
                        :state="errors[0] ? false : valid && dataContact.rule != null && dataContact.rule != '' ? true : null"
                      />

                      <b-form-invalid-feedback>
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-form-group>
                </template>
              </RowWrapper>
            </template>
          </RowWrapper>
          <div class="row">
            <div v-if="adding" class="d-flex justify-content-end m-2 w-100">
              <button class="btn btn-primary" @click.prevent="saveItem(validate)">
                Hoàn tất
              </button>
            </div>
            <div v-else class="d-flex justify-content-between m-2 w-100">
              <button class="btn btn-danger" @click="clickDelete(dataContact)">
                Xóa
              </button>
              <button class="btn btn-success" @click.prevent="saveItem(validate)">
                Lưu
              </button>
            </div>
          </div>
        </validation-observer>
      </b-modal>
      <el-dialog custom-class="popup-pos-detail" title="Xoá nhà cung cấp" :visible.sync="delSupplierModal" width="600px" :close-on-click-modal="false" append-to-body>
          <div class="text-center">
            <div class="modal-img"><img style="width:120px; margin:10px" src="@/assets/supplier-icons/del-supplier.png" /></div>
            <p style="margin-bottom:0">Bạn chắc chắn muốn xoá nhà cung cấp?</p>
            <p style="margin-bottom:0">Thao tác này không thể khôi phục</p>
          </div>
          <template slot="footer">
            <el-button class="esc-btn" type="text" @click="delSupplierModal = false">Thoát</el-button>
            <el-button
                type="danger" plain
                @click="deleteSupplier"
            >
                Xác nhận xóa
            </el-button>
          </template>
      </el-dialog>
      <el-dialog custom-class="popup-pos-detail" title="Xoá thông tin liên hệ" :visible.sync="delContactModal" width="600px" :close-on-click-modal="false" append-to-body>
          <div class="text-center">
            <div class="modal-img"><img style="width:120px; margin:10px" src="@/assets/supplier-icons/del-contact.png" /></div>
            <p style="margin-bottom:0">Bạn chắc chắn muốn xoá liên hệ “{{activeContact.name}}”?</p>
            <p style="margin-bottom:0">Thao tác này không thể khôi phục</p>
          </div>
          <template slot="footer">
            <el-button class="esc-btn" type="text" @click="delContactModal = false">Thoát</el-button>
            <el-button
                type="danger" plain
                @click="saveDelete"
            >
                Xác nhận xóa
            </el-button>
          </template>
      </el-dialog>
    </div>
    <NotPermission v-else></NotPermission>
  </div>
</template>

<style scoped>
.btn-filter {
  padding: 8px 20px;
}
</style>
